// Pillager patrols (MB.6). PURE (ENG-1).
//
// Roaming patrols spawn periodically once the early game is past — a small band
// led by a captain who carries the ominous banner (our banner-carrier convention
// is variant === 1, the same flag the raid trigger reads: killing it grants Bad
// Omen → a raid). This owns the spawn cadence + the band composition + the ring
// placement; the host spawns the mobs and flags the captain. The outpost tower
// structure (world-gen) is a separate slice.

/** No patrols before this world time — the first day or so stays quiet. */
export const PATROL_FIRST_TIME = 6000;
/** Game-ticks between patrol-spawn attempts (~10 min). */
export const PATROL_INTERVAL = 12000;
/** Chance an attempt actually spawns a patrol. */
export const PATROL_CHANCE = 0.2;
/** Pillagers in a patrol (one captain + the rest). */
export const PATROL_SIZE = 5;
/** How far from the player a patrol appears (blocks). */
export const PATROL_RING = 40;

/** Whether a patrol may attempt to spawn now (time gate + interval since last try). */
export function patrolDue(worldTime: number, lastAttempt: number): boolean {
  return worldTime >= PATROL_FIRST_TIME && worldTime - lastAttempt >= PATROL_INTERVAL;
}

/** Whether an attempt (roll 0..1) actually spawns. */
export function rollPatrol(roll01: number): boolean {
  return roll01 < PATROL_CHANCE;
}

/** The band composition — exactly one captain, at index 0 (the banner carrier). */
export function patrolMembers(size: number = PATROL_SIZE): { captain: boolean }[] {
  const n = Math.max(1, size | 0);
  return Array.from({ length: n }, (_, i) => ({ captain: i === 0 }));
}

/** A ring spawn point PATROL_RING blocks from (cx,cz) at `angle` radians. */
export function patrolSpawnPoint(cx: number, cz: number, angle: number): { x: number; z: number } {
  return { x: cx + Math.cos(angle) * PATROL_RING, z: cz + Math.sin(angle) * PATROL_RING };
}
